<div class="scroll-top-button" (click)="scrollToTop()">
	<i class="cfe cfe-up-arrow"></i>
</div>
